<template>
  <svg
    :aria-labelledby='iconName'
    :height='height'
    :viewBox='viewBox'
    :width='width'
    xmlns="http://www.w3.org/2000/svg"
  >
    <slot />
  </svg>
</template>

<script>
export default {
  name: 'WorkIconWrapper',
  props: {
    viewBox: { type: String, default: '0 0 24 24' },
    iconName: { type: String, default: '' },
    width: { type: [Number, String], default: 24 },
    height: { type: [Number, String], default: 24 },
  },
};
</script>
